import { c as patchEsm, b as bootstrapLazy } from './grasp-99e4b18e.js';
var defineCustomElements = function (win, options) {
    return patchEsm().then(function () {
        bootstrapLazy([["grasp-barcode", [[1, "grasp-barcode", { "data": [16] }]]]], options);
    });
};
export { defineCustomElements };
